export function formatDecimal(num: number, decimalPlaces: number, trailingZeroes: boolean = true): string {
  const wholeNumber = Math.floor(num);
  if(decimalPlaces <= 0) {
    return wholeNumber.toString();
  }
  const decimals = Math.floor((num % 1) * Math.pow(10, decimalPlaces));
  let decimalsStr;
  if(decimals === 0 && !trailingZeroes) {
    decimalsStr = '';
  } else if(trailingZeroes) {
    decimalsStr = `.${decimals.toString().padStart(decimalPlaces, '0')}`;
  } else {
    decimalsStr = `.${decimals.toString()}`;
  }
  return `${wholeNumber}${decimalsStr}`;
}

export function abbreviateNumber(num: number, separator?: boolean|string, decimalPlaces: number = 0) {
  let suffix = '';
  if(num >= 1000000000) {
    suffix = 'B';
    num = num / 1000000000;
  } else if(num >= 1000000) {
    suffix = 'M';
    num = num / 1000000;
  } else if(num >= 1000) {
    suffix = 'k';
    num = num / 1000;
  }
  let str = formatDecimal(num, decimalPlaces, false);
  if(separator !== false) {
    str = insertSeparators(str, typeof(separator) === 'string' ? separator : undefined);
  }
  return str + suffix;
}

export function insertSeparators(value: string|number, char?: string): string {
  const str = typeof(value) === 'string' ? value : value.toString();
  const periodIndex = str.indexOf('.');
  const wholeDigitsStr = periodIndex >= 0 ? str.substr(0, periodIndex) : str;
  const fractionalDigitsStr = periodIndex >= 0 ? str.substr(periodIndex) : '';
  if(!str || wholeDigitsStr.length <= 3) {
    return str;
  }
  if(!char) {
    char = ',';
  }
  const len = wholeDigitsStr.length;
  let output = '';
  for(let k = 0; k < len; k += 3) {
    let startIndex = len - k - 3;
    if(startIndex <= 0) {
      output = wholeDigitsStr.substr(0, 3 + startIndex) + output;
    } else {
      output = char + wholeDigitsStr.substr(startIndex, 3) + output;
    }
  }
  return output + fractionalDigitsStr;
}

export function formatPercentage(num: number, decimalPlaces: number = 0): string {
  if(decimalPlaces <= 0) {
    return Math.round(num * 100) + '%';
  } else {
    const pow = Math.pow(10, decimalPlaces);
    return Math.round(num * 100 * pow) / pow + '%';
  }
}
